import React from "react";
import { FaShippingFast, FaMobileAlt } from "react-icons/fa";
import { MdOutlinePriceChange } from "react-icons/md";
import "./TopBanner.scss";

const TopBanner = () => {
  return (
    <div className="top-banner">
      <div className="banner-item shipping">
        <FaShippingFast className="banner-icon" />
        <div className="banner-text">
          <span>Fast shipping on all orders &gt;</span>
          <small>Limited-time offers</small>
        </div>
      </div>
      <div className="banner-item price-adjustment">
        <MdOutlinePriceChange className="banner-icon" />
        <div className="banner-text">
          <span>Local Suppliers</span>
          <small>Next day delivery</small>
        </div>
      </div>
      <div className="banner-item app-promo">
        <FaMobileAlt className="banner-icon" />
        <a
          className="banner-text"
          href="https://qiktruck.co.za/?app=qikmarket"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>Get the QIKTRUCK App</span>
        </a>
      </div>
    </div>
  );
};

export default TopBanner;
